import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { SortType } from "@swimlane/ngx-datatable";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { ClienteInternacional } from "src/app/models/ClienteInternacional/ClienteInternacional";
import { ClienteInternacionalFilter } from "src/app/models/ClienteInternacional/ClienteInternacionalFilter";
import { ClienteInternacionalService } from "src/app/services/cliente-internacional.service";
import { PermissionService } from "src/app/services/permission.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import { ConfigClientesInternacionales } from "./config-clientes-internacionales";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';

@Component({
   selector: "app-mantenedor-clientes-internacionales",
   templateUrl: "./mantenedor-clientes-internacionales.component.html",
   styleUrls: ["./mantenedor-clientes-internacionales.component.scss"],
})
export class MantenedorClientesInternacionalesComponent implements OnInit {
   SortType = SortType;
   @ViewChild("currentSwal") private currentSwal: SwalComponent;
   public loading: boolean = false;
   public rowsMantenedor: ClienteInternacional[] = [];
   public selectedClient: ClienteInternacional;
   public selectedClientId: string;
   private emisorId: string = this.tokenStorage.getCompany();
   public configScroll: PerfectScrollbarConfigInterface = {};
   public page: Page = new Page();
   private filter = new ClienteInternacionalFilter();
   public createClientModal: NgbModalRef;
   public editClientModal: NgbModalRef;
   public detailClientModal: NgbModalRef;
   public setContractToNewClient: boolean = false;
   public editClientMode: boolean = false;
   public configLocal = ConfigClientesInternacionales;
   //public fakeContract:Contrato = new Contrato();
   public componentStarted: boolean = false;
   @ViewChild("tableMobile") tableRef: any;
   private closeActionsHandler: any;

   constructor(private modalService: NgbModal, private changeRef: ChangeDetectorRef, private internationalClientService: ClienteInternacionalService, private tokenStorage: TokenStorageService, private router: Router, public utilities: UtilitiesService, public permissions: PermissionService, private sessionUserService: SessionUserService) {}

   toggleActions(row: any): void {
		const newState = !row.showActions;
		this.rowsMantenedor.forEach(r => {
		  if (r !== row && r.showActions) {
			r.showActions = false;
			document.removeEventListener('click', this.closeActionsHandler);
		  }
		});
	  
		row.showActions = newState;
	  
		if (newState) {
		  this.closeActionsHandler = this.closeActionsMenu.bind(this, row);
		  setTimeout(() => document.addEventListener('click', this.closeActionsHandler), 0);
		} else {
		  document.removeEventListener('click', this.closeActionsHandler);
		}
	  }
	  
	closeActionsMenu(row: any, event: MouseEvent): void {
		if (!(event.target as HTMLElement).closest('.action-container')) {
			row.showActions = false;
			this.changeRef.detectChanges();
			document.removeEventListener('click', this.closeActionsHandler);
		}
	}

   public getTotalPages(rowCount: number, pageSize: number): number {
		if (!pageSize) { 
		  return 1; 
		}
		return Math.ceil(rowCount / pageSize);
	  }
   ngOnInit(): void {
      this.sessionUserService.verificarSesionUsuario();
      this.filter.emisorId = this.emisorId;
      this.filter.activo = true;
      this.setPage({ offset: 0 });
   }
   setPageSize() {
      //this.page.currentPageSize = this.page.page
      this.setPage({ offset: 0 });
   }
   setPage(pageInfo, $event?) {
      this.loading = true;
      this.page.pageNumber = pageInfo.offset;
      let localPage = JSON.parse(JSON.stringify(this.page));
      localPage.pageNumber += 1;

      this.internationalClientService
         .getDataByPage(this.filter, localPage)
         .subscribe(
            (result) => {
               this.rowsMantenedor = result.data as ClienteInternacional[];
               this.setPageFromResponse(this.page, result);
            },
            (error) => {
               this.currentSwal.icon = "error";
               this.currentSwal.title = "Error en Clientes";
               this.currentSwal.text = "No ha sido posible obtener la lista de clientes disponibles, favor recarge la página." + this.utilities.setErrorMessageFromArray(error.error);
               this.currentSwal.fire();
            }
         )
         .add(() => {
            this.loading = false;
            this.componentStarted = true;
            this.changeRef.detectChanges();
         });
   }

   openCreateClientModal(modalRef) {
      this.setContractToNewClient = false;
      this.createClientModal = this.modalService.open(modalRef, {
         windowClass: "",
         size: "lg",
      });
   }
   closeCreateClientModal() {
      //close modal from ClientEntry component event
      this.createClientModal.close();
   }

   sendOnlyClientRequest(clientRequest) {
      //send request to service
      clientRequest.emisorId = this.emisorId;
      this.loading = true;
      this.internationalClientService.sendClientRequest(clientRequest).subscribe(
         (result) => {
            this.currentSwal.title = "Cliente ingresado";
            this.currentSwal.text = "Se ha ingresado correctamente el nuevo cliente";
            this.currentSwal.icon = "success";
            this.currentSwal.fire();
            this.changeRef.detectChanges();

            this.setPage({ offset: 0 });
            this.changeRef.detectChanges();
            this.closeCreateClientModal();
         },
         (error) => {
            this.loading = false;
            this.changeRef.detectChanges();
            this.currentSwal.title = "Error en ingreso";
            this.currentSwal.text = "Ha ocurrido un error al intentar ingresar un nuevo cliente. " + this.utilities.setErrorMessageFromArray(error.error);
            this.currentSwal.icon = "error";
            this.currentSwal.fire();
         }
      );
   }

   deactivateClient(row: ClienteInternacional) {
      this.loading = true;
      this.internationalClientService
         .deactivateClient(row.clienteInternacionalId)
         .subscribe(
            (result) => {
               if (result.data) {
                  //row.activo = false;
                  this.setPage({ offset: 0 });
                  this.currentSwal.title = "Cliente desactivado";
                  this.currentSwal.text = "Se ha desactivado correctamente el cliente seleccionado";
                  this.currentSwal.icon = "success";
                  this.currentSwal.fire();
               }
            },
            (error) => {
               this.currentSwal.title = "Error en desactivación";
               this.currentSwal.text = "Ha ocurrigo un error al intentar desactivar el cliente." + this.utilities.setErrorMessageFromArray(error.error);
               this.currentSwal.icon = "error";
               this.currentSwal.fire();
            }
         )
         .add(() => {
            this.loading = false;
            this.changeRef.detectChanges();
         });
   }
   reactivateClient(row: ClienteInternacional) {
      if (row.activo) {
         this.currentSwal.title = "Error en desactivación";
         this.currentSwal.text = "Este cliente ya se encuentra activo";
         this.currentSwal.icon = "error";
         this.currentSwal.fire();
      } else {
         this.loading = true;
         let request: ClienteInternacional = new ClienteInternacional();
         request.activo = true;
         request.clienteInternacionalId = row.clienteInternacionalId;
         request.razonSocial = row.razonSocial;
         request.nombreFantasia = row.nombreFantasia;
         request.direccionCalle = row.direccionCalle;
         request.direccionNumero = row.direccionNumero;
         request.direccionLineaAdicional = row.direccionLineaAdicional;
         request.ciudad = row.ciudad;
         request.giro = row.giro;
         request.direccionEstadoRegion = row.direccionEstadoRegion;
         request.paisId = row.paisId;
         request.codigoPais = row.codigoPais;
         request.activo = row.activo;
         this.internationalClientService
            .reactivateClient(row.clienteInternacionalId)
            .subscribe(
               (result) => {
                  //row.activo = true;
                  this.setPage({ offset: 0 });
                  this.loading = false;
                  this.currentSwal.title = "Cliente Reactivado";
                  this.currentSwal.text = "Se ha reactivado correctamente al cliente seleccionado";
                  this.currentSwal.icon = "success";
                  this.currentSwal.fire();
               },
               (error) => {
                  this.loading = false;
                  this.currentSwal.title = "Error en activación";
                  this.currentSwal.text = "Ha ocurrigo un error al intentar reactivar el cliente." + this.utilities.setErrorMessageFromArray(error.error);
                  this.currentSwal.icon = "error";
                  this.currentSwal.fire();
               }
            )
            .add(() => {
               this.loading = false;
               this.changeRef.detectChanges();
            });
      }
   }
   openEditClientModal(modalRef, rowClient: ClienteInternacional) {
      this.selectedClient = rowClient;
      this.editClientMode = true;
      this.editClientModal = this.modalService.open(modalRef, {
         windowClass: "",
         size: "lg",
      });
   }
   closeEditClientModal() {
      this.editClientModal.close();
      this.editClientMode = false;
      this.selectedClient = undefined;
   }

   editClientRequest(editedClientRequest: ClienteInternacional) {
      //receive client request
      this.loading = true;
      editedClientRequest.emisorId = this.emisorId;
      this.internationalClientService
         .editClientRequest(this.selectedClient.clienteInternacionalId, editedClientRequest)
         .subscribe(
            (result) => {
               this.replaceClientInList(result.data);
               let clientRef = this.rowsMantenedor.find((client) => client.clienteInternacionalId == result.data.clienteInternacionalId);
               let index = this.rowsMantenedor.indexOf(clientRef);
               let newClient = result.data;
               this.rowsMantenedor.splice(index, 1, newClient);
               this.rowsMantenedor = [...this.rowsMantenedor];
               this.loading = false;
               this.setPage({ offset: 0 });
               this.currentSwal.title = "Cliente modificado";
               this.currentSwal.text = "Se han guardado correctamente los datos del cliente";
               this.currentSwal.icon = "success";
               this.currentSwal.fire();
            },
            (error) => {
               console.log(error);
               this.currentSwal.title = "Error en edición";
               this.currentSwal.text = "Ha ocurrigo un error al intentar guardar los cambios del cliente." + this.utilities.setErrorMessageFromArray(error.error);
               this.currentSwal.icon = "error";
               this.currentSwal.fire();
            }
         )
         .add(() => {
            //this.changeRef.detectChanges();
            //after response change editMode to false
            this.closeEditClientModal();
            this.loading = false;
            this.changeRef.detectChanges();
         });
   }

   // openAddContract(modalRef, rowClient: Receptor) {
   //   this.selectedClient = rowClient;
   //   this.createContract = this.modalService.open(modalRef, {
   //     windowClass: "",
   //     size: "lg",
   //   });
   // }

   // closeAddContractModal() {
   //   this.selectedClient = undefined;
   //   this.createContract.close();
   // }

   // openContractList(modalRef,rowClient:Receptor){
   //   this.selectedClient = rowClient;
   //   this.contractListRef=modalRef;
   //   this.contractListModal = this.modalService.open(modalRef,{
   //     windowClass:"",
   //     size:"lg"
   //   })
   // }

   // closeContractListModal(){
   //   this.selectedClient = undefined;
   //   this.contractListModal.close();
   // }

   openDetailsClient(modalRef, row: ClienteInternacional) {
      this.selectedClient = row;
      this.detailClientModal = this.modalService.open(modalRef, {
         windowClass: "",
         size: "lg",
      });
   }
   closeDetailsClient() {
      this.detailClientModal.close();
   }

   replaceClientInList(client: ClienteInternacional) {
      this.selectedClient = { ...client };
      let changeClient = this.rowsMantenedor.find((receptor) => receptor.clienteInternacionalId == client.clienteInternacionalId);
      let changeClientIndex = this.rowsMantenedor.indexOf(this.selectedClient);
      if (changeClientIndex !== -1) {
         this.rowsMantenedor[changeClientIndex] = { ...client };
      }
   }

   setPageFromResponse(currentPage: Page, data: PagedResponse<ClienteInternacional>) {
      currentPage.pageSize = data.pageSize;
      currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
      currentPage.totalPages = data.totalPages;
      currentPage.totalElements = data.totalRecords;
   }
   searchElementsByFilter(event) {
      let filterLocal = new ClienteInternacionalFilter();
      this.filter = { ...filterLocal };
      if (event.criterio == "rutReceptorDv") {
         this.filter[event.criterio] = event.busqueda;
      } else {
         this.filter[event.criterio] = event.busqueda;
      }
      this.filter = this.utilities.clearOtherFilterCriterias(event.criterio, this.filter, this.configLocal);
      this.filter.emisorId = this.emisorId;
      this.filter.activo = event.registroActivo ? false : true;
      this.filter.paisId = event.paisInline ? event.paisInline : "";
      this.setPage({ offset: 0 });
   }

   relatedDtes(row: ClienteInternacional) {
      let clientId = row.clienteInternacionalId;
      let nombre = row.razonSocial;
      this.router.navigateByUrl("/exportaciones", {
         state: { receptorNombre: nombre, filterDescription: "Filtrado por cliente " + nombre },
      });
   }
   exportToExcel() {
      this.getAllRowsByFilter(this.page, this.filter);
   }

   getAllRowsByFilter(currentPageRef: Page, currentFilter: ClienteInternacionalFilter) {
      let fullPage: Page = new Page();
      fullPage.pageSize = currentPageRef.totalElements;
      fullPage.pageNumber = 0;
      fullPage.totalElements = currentPageRef.totalElements;
      fullPage.totalPages = 1;
      this.loading = true;
      this.internationalClientService.getDataByPage(currentFilter, fullPage).subscribe(
         (result) => {
            let elements = result.data as ClienteInternacional[];
            this.loading = false;
            this.changeRef.detectChanges();
            this.exportExcelData(elements);
         },
         (error) => {
            this.loading = false;
            this.changeRef.detectChanges();
            this.currentSwal.icon = "error";
            this.currentSwal.title = "Error al exportar";
            this.currentSwal.text = "No es posible exportar los datos. Intente mas tarde. ";
            if (error.error.message) {
               this.currentSwal.text += this.utilities.setErrorMessageFromArray(error.error);
            }
         },
         () => {
            this.loading = false;
            this.changeRef.detectChanges();
         }
      );
   }

   exportExcelData(arrayToExport: Array<ClienteInternacional>): void {
      let arregloExportar = [];
      arrayToExport.forEach((row) => {
         let elementToExport = {};
         elementToExport["Razón Social"] = row.razonSocial;
         elementToExport["Giro"] = row.giro;
         //elementToExport["Dirección Particular"] = row.dirPart;
         elementToExport["Dirección (Calle)"] = row.direccionCalle;
         elementToExport["Dirección (Número)"] = row.direccionNumero;
         elementToExport["Dirección (Adicional)"] = row.direccionLineaAdicional;
         elementToExport["Estado / Región"] = row.direccionEstadoRegion;
         elementToExport["Ciudad"] = row.ciudad;
         elementToExport["Pais"] = row.paisId;
         arregloExportar.push(elementToExport);
      });
      this.utilities.exportAsExcelFile(arregloExportar, "clientes_internacionales");
   }
   toggleExpandRow(row) {
      this.tableRef.rowDetail.toggleExpandRow(row);
   }
}
